import Actions from "../actions";
import { produce } from "immer";

const initialState = {
  registerDetails: {},
  emailDetails: {},
  profileSetUpDetails: {},
  profileSetUpDetailsObject: {},
  user: {},
  countryList: [],
  stateList: [],
  cityList: [],
  userEmail: {},
  profileImageUrl: "",
  userProfileDetails: {},
  loginDetails: {},
  userConversionDialog: false,
};

export const cleanupStateList = () => ({
  type: Actions.CLEANUP_State_LIST,
});
export const cleanupCityList = () => ({
  type: Actions.CLEANUP_CITY_LIST,
});

const auth = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.PROVIDER_COUNTRY: {
      draft.countryList = payload?.countries;
      break;
    }
    case Actions.PROVIDER_STATE: {
      draft.stateList = payload?.states;
      break;
    }
    case Actions.PROVIDER_CITY: {
      draft.cityList = payload?.cities;
      break;
    }

    case Actions.PROVIDER_REGISTER_DETAILS: {
      draft.registerDetails = payload;
      break;
    }
    case Actions.PROVIDER_VERIFY_EMAIL: {
      draft.emailDetails = payload;
      break;
    }
    case Actions.PROVIDER_SET_UP_PROFILE: {
      draft.profileSetUpDetails = payload;
      break;
    }
    case Actions.PROVIDER_SET_UP_PROFILE_BANK_ACCOUNT: {
      draft.profileSetUpDetailsObject = payload;
      break;
    }
    case Actions.SET_USER_ROLE: {
      draft.user = { ...draft.user, role: payload };
      break;
    }

    case Actions.PROVIDER_FORGOT_PASSWORD: {
      draft.userEmail = payload;
      break;
    }
    case Actions.CLEANUP_State_LIST: {
      draft.stateList = [];
      break;
    }
    case Actions.CLEANUP_CITY_LIST: {
      draft.cityList = [];
      break;
    }
    case Actions.PROVIDER_PROFILE_IMAGE: {
      draft.profileImageUrl = payload;
      break;
    }
    case Actions.GET_OFFER_LIST: {
      draft.offerList = payload?.offers;
      break;
    }

    case Actions.PROVIDER_LOGIN: {
      draft.loginDetails = payload?.loginDetails;
      break;
    }

    case Actions.USER_CONVERSION_DIALOG_OPEN: {
      draft.userConversionDialog = true;
      break;
    }

    case Actions.USER_CONVERSION_DIALOG_FALSE: {
      draft.userConversionDialog = false;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default auth;
